import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from '@/data/locales/en.json'
import es from '@/data/locales/es.json'
import fr from '@/data/locales/fr.json'

const DEFAULT_NS = 'title'

i18n.use(initReactI18next).init({
  debug: process.env.NEXT_PUBLIC_I18N_DEBUG === 'true',
  fallbackLng: 'en',
  load: 'languageOnly',
  defaultNS: DEFAULT_NS,
  ns: [DEFAULT_NS],
  nsSeparator: false,
  lowerCaseLng: true,
  resources: {
    en: { [DEFAULT_NS]: en },
    es: { [DEFAULT_NS]: es },
    fr: { [DEFAULT_NS]: fr }
  },
  react: {
    useSuspense: false
  },
  interpolation: {
    escapeValue: false
  }
})

export default i18n
